import React, {Component} from 'react';
import {Link} from 'react-router-dom'; 
import { FaSignInAlt } from 'react-icons/fa';

class Footer extends Component {
  render(){
    return (
      <div className="footer">
        <div><Link className="login-link" to="/login"><FaSignInAlt /></Link></div>
        <div>&copy; Copyright CSI Inc, All rights reserved.</div>
      </div>
    );
  }
}

export default Footer;